/**
 * @param {string} url
 * @param {string} name
 * @param {string} options
 */
export const pop = (
  url,
  name = 'default',
  options = 'directories,location,menubar,resizable,scrollbars,status,toolbar',
) => {
  const popupWindow = typeof window !== 'undefined' ? window.open(url, name, options) : {};
  popupWindow?.focus();
};
/**
 * @param {Event & {currentTarget: {} }} e
 */
export const openPopUp = (e) => {
  e.preventDefault();

  const href = e.currentTarget.getAttribute('href');
  const hrefRegex = /pop\(([^)]+)\)/;
  const hrefParamsString = href.match(hrefRegex)[1];
  const paramsMatcher = /'([^']+)'/g;
  let paramMatch;
  const params = [];

  // we need to refactor this solution in future
  do {
    paramMatch = paramsMatcher.exec(hrefParamsString);
    if (paramMatch) {
      params.push(paramMatch[1]);
    }
  } while (paramMatch);

  pop(params[0], params[1], params[2]);
};
